import { getVisitorId } from '@/lib/growthTracking';

const API_URL = process.env.REACT_APP_BACKEND_URL;

// Bracket customization funnel. Each step is sent once per browser session per
// template; the server also keeps one row per visitor, step and day.
export function trackBracket(step, template) {
  const type = `bracket_${step}`;
  const onceKey = `sg_bk_${type}_${template}`;
  try {
    if (sessionStorage.getItem(onceKey)) return;
    sessionStorage.setItem(onceKey, '1');
  } catch { /* private mode: server dedupes */ }
  const token = localStorage.getItem('session_token');
  fetch(`${API_URL}/api/growth/events`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...(token ? { Authorization: `Bearer ${token}` } : {}) },
    body: JSON.stringify({ visitor_id: getVisitorId(), type, template }),
    keepalive: true,
  }).catch(() => {});
}

export async function authorizeCustomExport() {
  const token = localStorage.getItem('session_token');
  const res = await fetch(`${API_URL}/api/brackets/custom-export`, {
    method: 'POST', headers: token ? { Authorization: `Bearer ${token}` } : {},
  });
  return res.ok;
}
